import { useCallback } from 'react';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';
import { Canvas } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Canvas';
import { SendEmailNode } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Entities/Nodes/SendEmailNode';
import { uuid } from 'utils';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { NodeIds } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/utils/NodeTypeKeys';
import { useGetDisplayWebContentSelector } from '../../DisplayWebContent/state/selectors/useGetDisplayWebContentSelector';
import { useGetIsSplitTestSelector } from '../../../../state/SplitTests/selectors/useGetIsSplitTestSelector';

export const useAddSendEmailToWorkflow = () => {
  const { dispatch, state } = useWorkFlowCanvas();
  const { dispatch: editorDispatch } = useCampaignEditorContext();
  const getOnsiteMessage = useGetDisplayWebContentSelector();
  const isSplitTest = useGetIsSplitTestSelector();

  return useCallback(
    (addToId: string) => {
      const sendEmailId = uuid();
      const segmentId = uuid();

      const { nodes, edges } = Canvas.createFromState(state)
        .add(new SendEmailNode(sendEmailId), addToId)
        .convertToState();

      editorDispatch({
        type: 'ADD_SEND_EMAIL',
        payload: {
          id: sendEmailId,
          segmentId,
          onsiteSegmentId:
            addToId === NodeIds.dropzone
              ? undefined
              : isSplitTest(addToId)
              ? addToId
              : getOnsiteMessage(addToId)?.segmentId,
        },
      });

      dispatch({
        type: 'UPDATE',
        payload: {
          nodes,
          edges,
        },
      });
    },
    [dispatch, editorDispatch, getOnsiteMessage, isSplitTest, state],
  );
};
